<template lang="pug">
  div
    el-button.ButtonNext(@click="showDialog = true" type="primary") Siguiente
    v-dialog(v-model="showDialog" persistent  max-width="1000px" )
      v-layout(row, justify-center)
        v-flex(text-xs-center)
          v-card
            div(v-if="showDialog")
              v-layout
                v-flex(text-xs-center)
                  img.dialog_img(:src="getImage")
              v-spacer.my-1.py-4
              v-card.card(flat)
                v-card-text.dialog_text.textos2
                  div
                    span(v-html="getFeed") {{ getFeed }}
              v-spacer.my-1.py-4
              ButtonNext.buttones(@next="$emit('next')")
</template>
<script>
import { mapGetters } from 'vuex';
import ButtonNext from "@/components/button-next/button-next-end";
export default {
  name: 'FeedbackVideo',
  components: {
    ButtonNext
  },
  computed: {
    ...mapGetters(['currentStep']),
    getFeed(){
      let feed = this.currentStep.feed;
      return feed;
    },
    getFeedTitle(){
      let feedTitle = this.currentStep.feedTitle;
      return feedTitle;
    },
    getImage() {
        return require((this.getFeedback || {}).type === 'positive' ? '@/assets/semaforo.png' : '@/assets/semaforo.png');
    }
  },
	data(){
    return {
      showDialog: false,
      show: false,
      extra: false
		}
	},	
	methods:{
    changeExtra(){
      this.extra = !this.extra;
    },
    getText(text) {
      if(text) {
        let replaceData = text.split('|');
        if (replaceData.length > 1) {
          text = text.replace(`|${replaceData[1]}|`, this.currentStep.data[replaceData[1]]);
        }      
      }
      return text;
    }
  }
}
</script>

<style scoped>
@import 'feedback-modal.scss';
</style>
